import { render, staticRenderFns } from "./ArquivoBase.vue?vue&type=template&id=441161a4&scoped=true"
import script from "./ArquivoBase.vue?vue&type=script&lang=js"
export * from "./ArquivoBase.vue?vue&type=script&lang=js"
import style0 from "./ArquivoBase.vue?vue&type=style&index=0&id=441161a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441161a4",
  null
  
)

export default component.exports